// 协议版本号（与 LocalSend v2.1 信令兼容，便于未来与原生 APP 互通）
export const PROTOCOL_VERSION = '2.1';

// 应用品牌
export const APP_NAME = '快船';
export const APP_NAME_EN = 'KuaiChuan';
